import React, { useEffect, useState } from "react";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

am4core.useTheme(am4themes_animated);

const SemiCirclePieChart = ({ className, data, styles = {} }) => {
  useEffect(() => {
    let chart = am4core.create("chartdiv", am4charts.PieChart);
    // Set up data
    chart.data = data;

    // Create pie series
    let series = chart.series.push(new am4charts.PieSeries());

    // Apply CSS to create a semi-circle effect
    chart.radius = am4core.percent(70);
    chart.innerRadius = am4core.percent(40);
    chart.startAngle = 180;
    chart.endAngle = 360;
    chart.hiddenState.properties.opacity = 0; // this creates initial fade-in
    chart.logo.disabled = true;

    series.dataFields.value = "value";
    series.dataFields.category = "category";

    series.slices.template.cornerRadius = 5;
    series.slices.template.innerCornerRadius = 5;
    series.slices.template.draggable = false;
    series.colors.list = [
      // am4core.color("#03002F"),
      // am4core.color("#810B7D"),
      // am4core.color("#FE7B2C"),
      // am4core.color("#EEAD2D"),
      // am4core.color("#f5e342"),
      // am4core.color("#03002F"),
      // am4core.color("#810B7D"),

      am4core.color("#0469DC"),
      am4core.color("#59C3C3"),
      am4core.color("#F45B69"),
      am4core.color("#F0B642"),
      am4core.color("#FE7B2C"),
      am4core.color("#f5e342"),
      am4core.color("#4a4238"),
    ];
    series.hiddenState.properties.startAngle = 180;
    series.hiddenState.properties.endAngle = 90;

    series.labels.template.fontSize = 18;

    series.labels.template.disabled = false; // Hide labels
    series.legendSettings.labelText = ""; // Hide legend labels
    series.labels.template.fontFamily = "Roboto";
    series.labels.template.text = "{value.formatNumber('#.00')}%";
    series.slices.template.tooltipText = "{category}: {credit} ({value}%)";
    return () => {
      chart.dispose();
    };
  }, [data]);

  const [width, setWidth] = useState(275);

  const ref = React.createRef();

  useEffect(() => {
    setWidth(ref?.current?.offsetWidth);
    // eslint-disable-next-line
  }, [ref?.current]);

  return (
    <div
      ref={ref}
      id="chartdiv"
      className={className}
      style={{ ...styles, minHeight: (width / 100) * 51 }}
    />
  );
};

export default SemiCirclePieChart;
